import type { Manifest, v4 } from '@sap/ux-specification-types';
import { syncRule, validity } from '../../../common/decoration/decorators';
import { addPatternForBindingChangeOfEnumOPV4 } from '../../../common/decoration/control';
import { getCustomSectionActionPath } from '../../application';
/**
 * Sync class for Position
 */
export class CustomSectionActionPositionOP implements v4.CustomSectionActionPositionOP {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, actionId: string): string =>
                getCustomSectionActionPath(pageName, manifest, sectionId, actionId) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    anchor?: string;
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, actionId: string): string =>
                getCustomSectionActionPath(pageName, manifest, sectionId, actionId) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    placement: v4.ActionPlacement;
}

export class CustomSectionActionOP implements v4.CustomSectionActionOP {
    @syncRule({
        manifest: {
            path: getCustomSectionActionPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    text: string;

    @syncRule({
        manifest: {
            path: getCustomSectionActionPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    position: CustomSectionActionPositionOP;

    @syncRule({
        manifest: {
            path: getCustomSectionActionPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    press: string;

    @syncRule({
        manifest: {
            path: getCustomSectionActionPath
        },
        generate: addPatternForBindingChangeOfEnumOPV4
    })
    @validity({
        since: '1.84.0'
    })
    visible?: boolean;

    @syncRule({
        manifest: {
            path: getCustomSectionActionPath
        },
        generate: addPatternForBindingChangeOfEnumOPV4
    })
    @validity({
        since: '1.84.0'
    })
    enabled?: boolean;

    @syncRule({
        manifest: {
            path: getCustomSectionActionPath
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getCustomSectionActionPath
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}
